@if (hasNotificationsToShow | async) {
  <div class="notification-flash">
    @for (notification of notifications | async; track notification) {
      <ftr-notification [type]="notification.type">
        <div markdown>{{ notification.message }}</div>
      </ftr-notification>
    }
  </div>
}
